export default __webpack_public_path__ + "static/media/undraw_agree_8pb9.5859ae8c.svg";